import EventDispatcher from "js-class.event-dispatcher";

export default class Preview {
	constructor(param)
	{
		this.events = new EventDispatcher(this);
		this.param = param || {};
		this.dom = null
		this.dom__init();
	}

	on(eventName,callback) { this.events.registerEvent(eventName,callback); }
	off(eventName,callback) { this.events.unregisterEvent(eventName,callback); }
	fire(eventName,data) { this.events.fireEvent(eventName, data); }

	getParam(k=null) {
		if(typeof k === 'string')
			return this.param[k];
		return this.param;
	}
	setParam(k,v=null) {
		if(typeof k === 'string') {
			this.param[k] = v;
		}
		else if(typeof k === 'object') {
			for(let i in k)
			{
				this.param[i] = k[i];
			}
		}
		else {
			this.param = {};
		}
		this.dom__refresh();
	}
	loadParam(param) {
		this.param = param;
		this.dom__refresh();
	}

	dom__init() {
		this.dom = document.createElement('div')
		this.dom__refresh();
	}

	dom__refresh() {
		clearTimeout(this.dom__refresh_delay);
		this.dom__refresh_delay = setTimeout(this.dom__refresh_delayed.bind(this),1000);
	}

	dom__refresh_delayed() {
		if(this.param.provider && this.param.embed_id) {
			let param = [];
			param.push(`provider="${this.param.provider}"`)
			param.push(`embed-id="${this.param.embed_id}"`)
			if(this.param.embed_ratio) param.push(`embed-ratio="${this.param.embed_ratio}"`);

			if(this.param.height) param.push(`height="${this.param.height || "inherit"}"`);

			if(this.param.controls && typeof this.param.controls === "string")
				param.push(`controls="${this.param.controls}"`);
			else if(this.param.controls)
				param.push(`controls`);

			if(this.param.autoplay) param.push('autoplay');
			if(this.param.clickable) param.push('clickable');
			if(this.param.muted) param.push('muted');
			if(this.param.cover) param.push('cover');

			if(typeof this.param.loop === 'string')
				param.push('loop="'+this.param.loop+'"');
			else
				param.push('loop');

			this.dom.innerHTML = `<hapi-video ${param.join(' ')}></hapi-video><div part="preview-detail"></div>`;

			this.dom__duration_observer();
		}
		else
		{
			this.dom.innerHTML = ``;
		}
	}

	dom__duration_observer()
	{
		this.dom__refresh_delay = setTimeout(async () => {
			let player = this.dom.querySelector('hapi-video');
			let duration = player && typeof player.getDuration ==="function" ? await player.getDuration() : false
			if(!duration)
				this.dom__duration_observer();
			else
			{
				let s = duration+0;
				let h = Math.floor(s / 3600); s = s - 3600*h
				let m = Math.floor(s / 60); s = s - 60*m
				let time = [];
				if(h) time.push(h+'h');
				if(m) time.push(m+'m');
				if(s) time.push(s+'s');
				if(duration>60)
				{
					this.dom.querySelector('[part="preview-detail"]').innerHTML = '<strong>'+time.join(' ')+'</strong> / <span>'+duration+'s</span>';
				}
				else
				{
					this.dom.querySelector('[part="preview-detail"]').innerHTML = '<strong>'+time.join(' ');
				}
			}
		},200);
	}
}